import axios from "axios";
import helpers from "@/helpers.js";
import store from '../../store'
// import firebase from "firebase";

class CurrentUser {

    constructor() {

    }

    get() {

        let params = "" ;

      
        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };

            //params = params + "&company_id="+store.state.companies.currentCompany.id ;
            //params = params + "&company_id=1";
           
            return axios.get( 
                helpers.get_api_endpoint("/current-user",params),
                config
            ).then(function(response) {

                // console.log(response.data);
                store.commit("user/update_user", response.data)
                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

    hasRights(type, type_id, rights) {

        let params = "" ;

        params = params + "&type="+type;
        params = params + "&type_id="+type_id;
        params = params + "&rights="+rights;
        params = params + "&company_id="+store.state.companies.currentCompany.id ;
        
        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };
           
            return axios.get( 
                helpers.get_api_endpoint("/current-user/rights",params),
                config
            ).then(function(response) {

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

    update_meta(key, value) {

        let params = "" ;

        // params = params + "&company_id="+store.state.companies.currentCompany.id ;
        
        store.commit("app/SET_LOADER", true) ;

        return helpers.get_token().then(function(idToken) {
            
            const config = {
                headers: { Authorization: "Bearer " + idToken }
            };

            params = params + "&company_id="+store.state.companies.currentCompany.id ;
            params = params + "&key="+key ;
            params = params + "&value="+value ;
           
            return axios.put( 
                helpers.get_api_endpoint("/current-user/meta",params),
                config
            ).then(function(response) {

                // console.log('user meta written');
                store.commit("app/SET_LOADER", false) ;

                return response.data ; 

            })
            .catch(error => {
                store.commit("app/SET_ERROR", error) ;
                return error ; 
            });

        }).catch(function(error) {

            store.commit("app/SET_ERROR", error) ;
            return error ; 
  
        });
        
    }

    

    

}

export default CurrentUser ;
